import { render, staticRenderFns } from "./SupportTicketDialogClose.vue?vue&type=template&id=4e07cfef"
import script from "./SupportTicketDialogClose.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports